import AirCon from '@/assets/img/realtime/air-conditioner.svg'
import Thermometer from '@/assets/img/realtime/thermometer.svg'
import { DataType, IndicatorDataType, SpaceType, Mode } from './types'
import Remote from '@/assets/img/realtime/remote.svg'

import Restaurant from '@/assets/img/realtime/restaurant.webp'
import Office from '@/assets/img/realtime/office.webp'
import OpenSpace from '@/assets/img/realtime/open_space.webp'
import Other from '@/assets/img/realtime/other.webp'
import TechnicalZone from '@/assets/img/realtime/Technical_Zone.webp'
import Room from '@/assets/img/realtime/bedroom.webp'
import CommonSpace from '@/assets/img/realtime/Common_Space.webp'

import CoolModeSvg from '@/assets/img/realtime/cool-mode.svg'
import FanModeSvg from '@/assets/img/realtime/fan-mode.svg'
import HeatModeSvg from '@/assets/img/realtime/heat-mode.svg'
import AutoModeSvg from '@/assets/img/realtime/auto-mode.svg'
import IdleModeSvg from '@/assets/img/realtime/idle-mode.svg'

export const DATA_TYPE_ICONS_SRC: Record<IndicatorDataType, string> = {
    [DataType.STATE]: Remote,
    [DataType.TEMPERATURE]: Thermometer,
    [DataType.SETPOINT_TEMPERATURE]: AirCon,
}

export const SPACE_TYPE_IMG_SRC: Record<SpaceType, string> = {
    [SpaceType.HOTEL_ROOM]: Room,
    [SpaceType.COMMON_AREA]: CommonSpace,
    [SpaceType.RESTAURANT]: Restaurant,
    [SpaceType.TECHNICAL_ZONE]: TechnicalZone,
    [SpaceType.OFFICE]: Office,
    [SpaceType.MEETING_ROOM]: TechnicalZone,
    [SpaceType.OPEN_SPACE]: OpenSpace,
    [SpaceType.OTHER]: Other,
}

export const SPACE_TYPE_DISPLAY_ORDER: SpaceType[] = [
    SpaceType.HOTEL_ROOM,
    SpaceType.COMMON_AREA,
    SpaceType.OPEN_SPACE,
    SpaceType.OFFICE,
    SpaceType.MEETING_ROOM,
    SpaceType.RESTAURANT,
    SpaceType.TECHNICAL_ZONE,
    SpaceType.OTHER,
]

export const MODE_ICONS: Record<Mode, string | undefined> = {
    [Mode.HEAT]: HeatModeSvg,
    [Mode.COOL]: CoolModeSvg,
    [Mode.AUTO]: AutoModeSvg,
    [Mode.FAN]: FanModeSvg,
    [Mode.IDLE]: IdleModeSvg,
    // An unreadable mode must stay unreadable: falling back to the AUTO badge
    // made every Gridone thermostat claim a mode it was never in.
    [Mode.UNKNOWN]: undefined,
}
